export default {
  methods: {
    toastNotification: function (msg, options) {
        return this.$bvToast.toast(msg, options);
    },
    quickToast: function (title, msg, variant) {
        return this.toastNotification(msg, {
            title: title,
            variant: variant
        });
    },
    quickSuccessToast: function (title, msg) {
        return this.quickToast(title, msg, 'success');
    },
    quickDangerToast: function (title, msg) {
        return this.quickToast(title, msg, 'danger');
    },
    quickWarningToast: function (title, msg) {
        return this.quickToast(title, msg, 'warning');
    },
    quickInfoToast: function (title, msg) {
        return this.quickToast(title, msg, 'info');
    },
  }
}